import axios from "./axios";
import { NINJA_3_ENDPOINT } from "./endpoint";
let ajaxRequest = null;

export const GetProducts = workspaceId => {
  if (ajaxRequest) {
    ajaxRequest.cancel();
  }
  ajaxRequest = axios.CancelToken.source();

  return axios.get(
    `${NINJA_3_ENDPOINT}/api/products/?workspace_id=${workspaceId}`,
    { cancelToken: ajaxRequest.token }
  );
};

export const SaveScheduler = scheduler => {
  return axios.post(`${NINJA_3_ENDPOINT}/api/ninja-product-scheduler/`, {
    ...scheduler
  });
};

export const GetScheduler = productId => {
  return axios.get(
    `${NINJA_3_ENDPOINT}/api/ninja-product-scheduler/?product_id=${productId}`
  );
};

export const GetSchedulerInfo = productId => {
  return axios.get(
    `${NINJA_3_ENDPOINT}/api/ninja-product-scheduler/get-schedule-info/?product_id=${productId}`
  );
};

export const GetResendServices = productId => {
  return axios.get(
    `${NINJA_3_ENDPOINT}/api/ninja-product-service/get/?product_id=${productId}`
  );
};

export const DeleteScheduler = schedulerId => {
  return axios.delete(
    `${NINJA_3_ENDPOINT}/api/ninja-product-scheduler/${schedulerId}`
  );
};

export const UpdateProduct = (productId, data) => {
  return axios.put(`${NINJA_3_ENDPOINT}/api/products/${productId}/`, data);
};

export const AddProduct = data => {
  return axios.post(`${NINJA_3_ENDPOINT}/api/products/add_product/`, data);
};

export const GetProductData = (productId, createDate, templateId) => {
  return axios.get(
    `${NINJA_3_ENDPOINT}/api/product-data/${productId}/get-send-list-data/?template_id=${templateId}${
      createDate ? "&create_date=" + createDate : ""
    }`
  );
};

export const GetSendlistDataHtml = (productId, sendListId) => {
  return axios.get(
    `${NINJA_3_ENDPOINT}/api/product-data/${productId}/get-data-html/?send_list_id=${sendListId}`
  );
};

export const GetSendlistData = (productId, sendListId) => {
  return axios.get(
    `${NINJA_3_ENDPOINT}/api/product-data/${productId}/get-data/?send_list_id=${sendListId}`
  );
};

export const ChangeData = data => {
  return axios.post(
    `${NINJA_3_ENDPOINT}/api/product-data/change-view-data/`,
    data
  );
};

export const GetProductDates = (productId, templateId) => {
  return axios.get(
    `${NINJA_3_ENDPOINT}/api/product-data/${productId}/get-available-dates/?template_id=${templateId}`
  );
};

export const CreateSql = templateId => {
  return axios.post(
    `${NINJA_3_ENDPOINT}/api/producttemplatesdetails/create-sql/`,
    {
      templateId
    }
  );
};

export const CreateSendlist = productId => {
  return axios.get(
    `${NINJA_3_ENDPOINT}/api/product-data/${productId}/create-sendlist/`
  );
};

export const CreateHistory = templateId => {
  return axios.get(
    `${NINJA_3_ENDPOINT}/api/product-data/create-history/?template_id=${templateId}`
  );
};

export const DeleteProduct = productId => {
  return axios.delete(
    `${NINJA_3_ENDPOINT}/api/products/${productId}/delete-product`
  );
};

export const DuplicateProduct = (productId, productName) => {
  return axios.post(
    `${NINJA_3_ENDPOINT}/api/producttemplatesdetails/duplicate-template/`,
    {
      productId,
      productName
    }
  );
};
